import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { X } from 'lucide-react';

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check URL param for forced display (for testing)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('resetConsent') === 'true') {
      localStorage.removeItem('cookieConsent');
      localStorage.removeItem('pwaGuideDismissed');
    }
    
    const accepted = localStorage.getItem('cookieConsent');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-900 text-white p-4 z-50 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm font-medium mb-1">{t('cookie.title')} 🍪</p>
          <p className="text-xs text-slate-300">{t('cookie.message')}</p>
        </div>
        <div className="flex items-center gap-3">
          <a 
            href="/privacy" 
            className="text-xs text-blue-400 hover:text-blue-300 underline"
          >
            {t('cookie.moreInfo')}
          </a>
          <Button 
            onClick={accept}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 text-sm rounded-full"
          >
            {t('cookie.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
}
